var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:" d-flex justify-center px-4 py-3"},[_c('v-img',{staticClass:"logo",attrs:{"src":_vm.logoUrl}})],1),_c('v-divider',{staticClass:"divider"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }